var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRefundReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90474 2.91345C2.91561 2.90237 2.9269 2.8917 2.9386 2.88149C3.17429 2.67521 3.53288 2.68443 3.75758 2.90913L5.42425 4.5758C5.65856 4.81012 5.65856 5.19001 5.42425 5.42433C5.18993 5.65864 4.81003 5.65864 4.57572 5.42433L3.93315 4.78176V11.3335C3.93315 11.7388 4.26119 12.0669 4.66649 12.0669H8.66649C8.99786 12.0669 9.26649 12.3355 9.26649 12.6669C9.26649 12.9982 8.99786 13.2669 8.66649 13.2669H4.66649C3.59845 13.2669 2.73315 12.4016 2.73315 11.3335V4.78209L2.09091 5.42433C1.8566 5.65864 1.4767 5.65864 1.24239 5.42433C1.00807 5.19001 1.00807 4.81012 1.24239 4.5758L2.90474 2.91345Z",
    fill: "#8145B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33315 2.7334C7.00178 2.7334 6.73315 3.00203 6.73315 3.3334C6.73315 3.66477 7.00178 3.9334 7.33315 3.9334H11.3332C11.7385 3.9334 12.0665 4.26144 12.0665 4.66673V11.2181L11.0909 10.2425C10.8566 10.0082 10.4767 10.0082 10.2424 10.2425C10.0081 10.4768 10.0081 10.8567 10.2424 11.091L12.2351 13.0837C12.2683 13.1181 12.3055 13.1484 12.3461 13.1741C12.424 13.2234 12.5142 13.2553 12.6109 13.2642C12.7825 13.2801 12.9596 13.2224 13.0909 13.091L15.0909 11.091C15.3252 10.8567 15.3252 10.4768 15.0909 10.2425C14.8566 10.0082 14.4767 10.0082 14.2424 10.2425L13.2665 11.2184V4.66673C13.2665 3.59869 12.4012 2.7334 11.3332 2.7334H7.33315Z",
    fill: "#8145B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRefundReturned);
export default __webpack_public_path__ + "static/media/ArrowRefundReturned.9665549eacfbb62d382a8fed2fb3110d.svg";
export { ForwardRef as ReactComponent };